import styled from 'styled-components'

export const SelectContainer = styled.div`
    position: relative;
    width: min(100%, 9.5rem);
`

export const Select = styled.select`
    width: 100%;
    height: 1.75rem;
    border-radius: 999px;
    border: 1px solid #d1d5db;
    padding: 0 1.8rem 0 0.5rem;
    background-color: #EBEBEB;
    color: #111827;
    font-size: 0.86rem;
    box-sizing: border-box;
    appearance: none;

    &:focus {
        border-color: #93c5fd;
        box-shadow: 0 0 0 2px rgba(147, 197, 253, 0.35);
    }
`

export const SelectArrow = styled.img`
    position: absolute;
    right: 0.8rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;
    height: 1rem;
    pointer-events: none;
`

export const Actions = styled.div`
    display: flex;
    gap: 24px;
`